import { useQuery } from '@apollo/client';
import {
    ExternalFinancialEntity,
    transactionSchedulesFromGoalAccount,
} from '../../financialEntities';
import { Goal } from '../../goals';
import {
    AllFinancialEntitiesDocument,
    TransactionScheduleFieldsFragment,
} from '../../graphql/generated';
import { sortBy } from '../../util/arrays';
import { isNotNullish } from '../../util/types';
import { getGoalAccounts } from '../goals/getGoalAccounts';
import { goalsFromFragments } from '../goals/goalsFromFragments';

interface GoalFundedByAccountInfo {
    goal: Goal;
    transactionSchedules: TransactionScheduleFieldsFragment[];
}

export const useGoalsFundedByAccount = (
    account?: ExternalFinancialEntity
): GoalFundedByAccountInfo[] => {
    // Determine goals that are funded by supplied FE
    const { data } = useQuery(AllFinancialEntitiesDocument);

    if (!account || !data) return [];

    const goalsFundedByAccount = goalsFromFragments(data.goals).reduce<
        GoalFundedByAccountInfo[]
    >((memo, goal) => {
        // Find goal transaction schedules where this FE is the source
        const transactionSchedules = getGoalAccounts(goal)
            .flatMap(transactionSchedulesFromGoalAccount)
            .filter(isNotNullish)
            .filter((ts) => ts && ts.sourceId === account.id);
        if (transactionSchedules.length > 0) {
            memo.push({ goal, transactionSchedules });
        }
        return memo;
    }, []);

    return sortBy(goalsFundedByAccount, ({ goal }) => goal.createdAt, 'ASC');
};
